<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>
            <div>콘첸츠 정보</div>
          </strong>
        </div>

        <div v-if="isLoading" sm="12">
          <div class="text-center toploadingbar" style="margin:300px 0 180px 0">
            <div style="width:200px; margin:0 auto; vertical-align:middle">
              <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
              <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
            </div>
          </div>
        </div>

        <div v-else class="table-responsive-sm">
          <table class="table">
            <tbody>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">카테고리</th>
              <td colspan="3">{{productInfoItems.top_type_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">보고서코드</th>
              <td colspan="3">{{productInfoItems.p_code}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">보고서명</th>
              <td colspan="3">{{productInfoItems.p_name}}</td>
            </tr>
<!--            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">부제목</th>
              <td colspan="3">{{reportInfoItems.sub_report_name}}</td>
            </tr>-->
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">등록자</th>
              <td colspan="3">{{productInfoItems.reg_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">금액</th>
              <td>
                  {{ productInfoItems.min_price }}원 ~ {{ productInfoItems.max_price }}
              </td>
              <th scope="row" class="bg-light text-center" style="width:150px;">노출여부</th>
              <td>{{productInfoItems.view_name}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">출시일</th>
              <td>{{productInfoItems.custom_date}}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">등록일</th>
              <td>{{productInfoItems.product_reg_date}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">조회수</th>
              <td>{{productInfoItems.total_view_cnt}}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">추천수</th>
              <td>{{productInfoItems.total_reco_cnt}}</td>
            </tr>
            <tr>
              <th scope="row" class="bg-light text-center" style="width:150px;">다운로드수</th>
              <td>{{productInfoItems.total_dl_cnt}}</td>
              <th scope="row" class="bg-light text-center" style="width:150px;">후속연구요청수</th>
              <td>{{productInfoItems.total_research_cnt}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>


export default {
  name: 'ArInfoTop',
  props: {
    productInfoItems: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
  },
  data () {
    return {
      productcode: '',
    }
  },
  mounted() {


  },
  methods: {

  },
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/component/ArInfo/ArInfoTop.vue